export enum DialogResultType {
  Cancel = 0,
  Dismiss = 1,
  Proceed = 2,
}

export interface DialogResult<T> {
  type: DialogResultType;
  data?: T;
}

export interface ProceedDialogResult<T = unknown> extends DialogResult<T> {
  type: DialogResultType.Proceed;
}

export interface DismissDialogResult<T = unknown> extends DialogResult<T> {
  type: DialogResultType.Dismiss;
}

export interface CancelDialogResult<T = unknown> extends DialogResult<T> {
  type: DialogResultType.Cancel;
}

export interface DialogActions<P = unknown | undefined, D = unknown | undefined, C = unknown | undefined> {
  proceed: (value?: P) => void;
  dismiss: (value?: D) => void;
  cancel: (value?: C) => void;
}
